import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: translate(-50%, -50%) scale(1.3); }
  to   { opacity: 1; transform: translate(-50%, -50%) scale(1); }
`;

export const Container = styled.div<{ $isActive: boolean }>`
  position: fixed;
  pointer-events: none;
  z-index: 10;
  display: none;
  transform: translate(-50%, -50%);
  filter: drop-shadow(0 0 6px rgba(0, 255, 136, 0.5));

  ${({ $isActive }) =>
    $isActive &&
    css`
      display: block;
      animation: ${fadeIn} 0.3s ease-out;
    `}

  svg {
    width: 120px;
    height: 120px;

    @media (max-width: 768px) {
      width: 80px;
      height: 80px;
    }

    @media (max-height: 500px) and (orientation: landscape) {
      width: 60px;
      height: 60px;
    }
  }
`;
